/**
 * Dashboard
 * @namespace gplans.dashboard.services
 */
(function () {
  'use strict';Funnel.$inject = ["$rootScope", "$q", "$state", "$localStorage", "$http", "$sce", "$location", "$stateParams", "Authentication"];
  angular.
  module('gplans.layout.services').
  factory('Funnel', Funnel);

  Funnel.$inject = ['$rootScope', '$q', '$state', '$localStorage', '$http', '$sce', '$location', '$stateParams', 'Authentication'];

  function Funnel($rootScope, $q, $state, $localStorage, $http, $sce, $location, $stateParams, Authentication) {
    var _defaultLocation = 'US';
    var _location = _defaultLocation;
    var _user = null;
    var _is_finish_quiz = null;
    var _state;
    var quiz_states = ['base.select_meta', 'base.survey_start', 'survey.question', 'base.start_quiz_and_run'];
    var payment_states = ['base.complete', 'base.store', 'base.store_payment', 'base.store_payment_take10'];

    var _funnelNextStepDict = {
      default1: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_upsell_nutritionist');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } },

        { // DownsellController
          condition: function condition() {
            return $state.current.name == 'base.store_downsell';
          },
          action: function action(callback) {
            $state.go('base.store_upsell_next');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_upsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: 'pro' });
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_downsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: 'pro' });
          } }] },



      straightSale: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action(callback) {
            callback();
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.select_meta');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback, param) {
            $state.go('base.store_account_info', { plan: param });
          } }] },



      CbMatt: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_upsell_nutritionist');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } },

        { // DownsellController
          condition: function condition() {
            return $state.current.name == 'base.store_downsell';
          },
          action: function action(callback) {
            $state.go('base.store_upsell_next');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_upsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_downsell');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_downsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_downsell', { plan: 'pro' });
          } }] },



      CbMattUS: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_shopify_upsell');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } },

        { // ShopifyUpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_shopify_upsell';
          },
          action: function action() {
            $state.go('base.store_downsell_nutritionist');
          } },

        { // DownsellController
          condition: function condition() {
            return $state.current.name == 'base.store_downsell';
          },
          action: function action(callback) {
            $state.go('gplansApp.dashboard.index');
          } },

        {
          // Upsell Nutritionist
          condition: function condition() {
            return $state.current.name == 'base.store_upsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: 'pro' });
          } },

        {
          // Downsell Nutritionist
          condition: function condition() {
            return $state.current.name == 'base.store_downsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: 'pro' });
          } }] },



      Alan: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_shopify_upsell');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } },

        { // ShopifyUpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_shopify_upsell';
          },
          action: function action() {
            $state.go('base.store_downsell_nutritionist');
          } },

        { // DownsellController
          condition: function condition() {
            return $state.current.name == 'base.store_downsell';
          },
          action: function action() {
            $state.go('gplans.userConsole');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_upsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: 'pro' });
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_downsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: 'pro' });
          } }] },



      John: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_shopify_upsell');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } },

        { // ShopifyUpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_shopify_upsell';
          },
          action: function action() {
            $state.go('base.store_upsell_nutritionist');
          } },

        { // DownsellController
          condition: function condition() {
            return $state.current.name == 'base.store_downsell';
          },
          action: function action(callback) {
            $state.go('base.store_upsell_next');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_upsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_downsell');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_downsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_downsell', { plan: 'pro' });
          } }] },



      Free: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: $stateParams.plan });
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } }] },



      NoTimer: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_upsell_nutritionist');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } },

        { // DownsellController
          condition: function condition() {
            return $state.current.name == 'base.store_downsell';
          },
          action: function action(callback) {
            $state.go('base.store_upsell_next');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_upsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_downsell');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_downsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_downsell', { plan: 'pro' });
          } }] },



      ControlUS: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_shopify_upsell');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } },

        { // ShopifyUpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_shopify_upsell';
          },
          action: function action() {
            $state.go('base.store_downsell_nutritionist');
          } },

        { // DownsellController
          condition: function condition() {
            return $state.current.name == 'base.store_downsell';
          },
          action: function action(callback) {
            $state.go('gplansApp.dashboard.index');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_upsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: 'pro' });
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_downsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_upsell', { plan: 'pro' });
          } }] },



      ControlInt: {
        steps: [
        { // SurveyCalculateController
          condition: function condition() {
            return $state.current.name == 'base.calculate';
          },
          action: function action() {
            $state.go('funnel.register_after_quiz');
          } },

        { // AccountInfoController
          condition: function condition() {
            return $state.current.name == 'base.store_account_info';
          },
          action: function action() {
            $state.go('base.store_upsell_nutritionist');
          } },

        { // UpsellController
          condition: function condition() {
            return $state.current.name == 'base.store_upsell';
          },
          action: function action(callback) {
            callback();
          } },

        { // DownsellController
          condition: function condition() {
            return $state.current.name == 'base.store_downsell';
          },
          action: function action(callback) {
            $state.go('base.store_upsell_next');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_upsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_downsell');
          } },

        {
          condition: function condition() {
            return $state.current.name == 'base.store_downsell_nutritionist';
          },
          action: function action() {
            $state.go('base.store_downsell', { plan: 'pro' });
          } }] } };





    var conditions = {
      'quiz-finished': function quizFinished() {
        return _is_finish_quiz && _is_finish_quiz.length >= 14;
      },
      'quiz-part': function quizPart() {
        return _is_finish_quiz && _is_finish_quiz.length < 14;
      },
      'measurements-done': function measurementsDone() {
        return window.gplansStorage.gender && window.gplansStorage.height && window.gplansStorage.current_weight &&
        window.gplansStorage.goal_weight && window.gplansStorage.age;
      },
      'user-exist': function userExist() {
        return _user;
      },
      'payed': function payed() {
        return _user && _user.is_payed;
      },
      'password-changed': function passwordChanged() {
        return _user && _user.is_password_changed;
      },
      'user-saved-in-ss': function userSavedInSs() {
        return _user && _user.last_checkin;
      } };


    var pageConditions = {
      // CbMatt offer conditions
      '!quiz_part-quiz-measurements-user-payed-password': { // user finish funnel
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          conditions['user-exist']() && conditions['payed']() && conditions['password-changed']();
        },
        action: function action() {
          if (confirm('You already finished this step and can be redirect to dashboard, ok?')) {
            $state.go('gplans.userConsole');
          }
        } },

      '!quiz_part-quiz-measurements-user-payed-!password': { // user bought plan, quiz finished, but didn't changed password
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          conditions['user-exist']() && conditions['payed']() && !conditions['password-changed']();
        },
        action: function action() {
          if (confirm('You already finished this step and can be redirect to password set page, ok?')) {
            $state.go('base.store_account_info', { plan: _user.subscription_plan.slug });
          }
        } },

      '!quiz_part-quiz-measurements-user-!payed-!password': { // user finished quiz, but didn't bought plan
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          conditions['user-exist']() && !conditions['payed']() && !conditions['password-changed']();
        },
        action: function action() {
          if (['base.store_account_info'].indexOf($state.current.name) > -1) {
            if (confirm('Before this step you need to buy plan, ok?')) {
              $state.go('base.store');
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to payment page, ok?')) {
              $state.go('base.store');
            }
          }
        } },

      '!quiz_part-quiz-measurements-!user-!payed-!password': { // user didn't set email, quiz and measurement done
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          !conditions['user-exist']() && !conditions['payed']() && !conditions['password-changed']();
        },
        action: function action() {
          if (['base.store'].indexOf($state.current.name) > -1) {
            if (confirm('Before this step you need to set your email, ok?')) {
              $state.go('funnel.register_after_quiz');
            }
          } else
          if (['base.store_account_info'].indexOf($state.current.name) > -1) {
            if (confirm('Before this step you need to buy plan, ok?')) {
              $state.go('base.store_payment_before_quiz');
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to user registration page, ok?')) {
              $state.go('funnel.register_after_quiz');
            }
          }
        } },

      '!quiz_part-quiz-!measurements-!user-!payed-!password': { // user didn't set measurement and finish quiz
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && !conditions['measurements-done']() &&
          !conditions['user-exist']() && !conditions['payed']() && !conditions['password-changed']();
        },
        action: function action() {
          if (['base.calculate', 'funnel.register_after_quiz'].indexOf($state.current.name) > -1) {
            if (confirm('Before this step you need to set measurement, ok?')) {
              $state.go('survey.weight_age_form', { surveyId: $localStorage['userSurvey'] });
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to measurement page, ok?')) {
              $state.go('survey.weight_age_form', { surveyId: $localStorage['userSurvey'] });
            }
          }
        } },

      'quiz_part-!quiz-!measurements-!user-!payed-!password': { // user finish part of quiz
        condition: function condition() {
          if ($state.current.name == 'survey.question')
          return conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() && !conditions['user-exist']() && !conditions['payed']() &&
          !conditions['password-changed']() && $stateParams.question != _is_finish_quiz.length + 1;else

          return conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() && !conditions['user-exist']() && !conditions['payed']() &&
          !conditions['password-changed']();
        },
        action: function action() {
          if ($stateParams.question > _is_finish_quiz.length + 1) {
            if (confirm('You must be redirect to quiz question page, ok?')) {
              $state.go('survey.question', { surveyId: 1, question: _is_finish_quiz.length + 1 });
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to quiz question page, ok?')) {
              $state.go('survey.question', { surveyId: 1, question: _is_finish_quiz.length + 1 });
            }
          }
        } },

      '!quiz_part-!quiz-!measurements-!user-!payed-!password': { // user do nothing
        condition: function condition() {
          return !conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() &&
          !conditions['user-exist']() && !conditions['payed']() && !conditions['password-changed']() &&
          ['base.select_meta', 'base.survey_start', 'base.start_quiz_and_run'].indexOf($state.current.name) == -1 && $stateParams.question != 1;
        },
        action: function action() {
          if (confirm('You need to start quiz from begin, ok?')) {
            $state.go('survey.question', { surveyId: 1, question: 1 });
          }
        } },


      // straight sale conditions
      'user-payed-password-!quiz_part-quiz-measurements-saved': { // user finish funnel
        condition: function condition() {
          return conditions['payed']() && conditions['user-exist']() && conditions['password-changed']() &&
          !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          conditions['user-saved-in-ss']();

        },
        action: function action() {
          if (confirm('You already finished this step and can be redirect to dashboard, ok?')) {
            $state.go('gplans.userConsole');
          }
        } },

      'user-payed-password-!quiz_part-quiz-measurements-!saved': {
        condition: function condition() {
          return conditions['payed']() && conditions['user-exist']() && conditions['password-changed']() &&
          !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          !conditions['user-saved-in-ss']();

        },
        action: function action() {
          if (confirm('You already finished this step and can be redirect to calculate page, ok?')) {
            $state.go('base.calculate', { surveyId: $localStorage['userSurvey'] });
          }
        } },

      'user-payed-password-!quiz_part-quiz-!measurements-!saved': {
        condition: function condition() {
          return conditions['payed']() && conditions['user-exist']() && conditions['password-changed']() &&
          !conditions['quiz-part']() && conditions['quiz-finished']() && !conditions['measurements-done']() &&
          !conditions['user-saved-in-ss']();

        },
        action: function action() {
          if (confirm('You already finished this step and can be redirect to measurement page, ok?')) {
            $state.go('survey.weight_age_form', { surveyId: $localStorage['userSurvey'] });
          }
        } },

      'user-payed-password-quiz_part-!quiz-!measurements-!saved': {
        condition: function condition() {
          if ($state.current.name == 'survey.question')
          return conditions['payed']() && conditions['user-exist']() && conditions['password-changed']() &&
          conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() &&
          $stateParams.question != _is_finish_quiz.length + 1 && !conditions['user-saved-in-ss']();else

          return conditions['payed']() && conditions['user-exist']() && conditions['password-changed']() &&
          conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() &&
          !conditions['user-saved-in-ss']();
        },
        action: function action() {
          if ($stateParams.question > _is_finish_quiz.length + 1) {
            if (confirm('You must be redirect to quiz question page, ok?')) {
              $state.go('survey.question', { surveyId: 1, question: _is_finish_quiz.length + 1 });
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to quiz question page, ok?')) {
              $state.go('survey.question', { surveyId: 1, question: _is_finish_quiz.length + 1 });
            }
          }
        } },

      'user-payed-password-!quiz_part-!quiz-!measurements-!saved': {
        condition: function condition() {
          return conditions['payed']() && conditions['user-exist']() && conditions['password-changed']() &&
          !conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() &&
          !conditions['user-saved-in-ss']();

        },
        action: function action() {
          if (confirm('You already finished this step and can be redirect to quiz page, ok?')) {
            $state.go('survey.question', { surveyId: 1, question: 1 });
          }
        } },

      'user-payed-!password-!quiz_part-!quiz-!measurements-!saved': {
        condition: function condition() {
          return conditions['payed']() && conditions['user-exist']() && !conditions['password-changed']() &&
          !conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() &&
          !conditions['user-saved-in-ss']();

        },
        action: function action() {
          if (quiz_states.indexOf($state.current.name) > -1) {
            if (confirm('You need to set password before. Redirect?')) {
              $state.go('base.store_account_info', { plan: _user.subscription_plan.slug });
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to password set page, ok?')) {
              $state.go('base.store_account_info', { plan: _user.subscription_plan.slug });
            }
          }
        } },

      'user-!payed-!password-!quiz_part-!quiz-!measurements-!saved': {
        condition: function condition() {
          return conditions['payed']() && !conditions['user-exist']() && !conditions['password-changed']() &&
          !conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() &&
          !conditions['user-saved-in-ss']();

        },
        action: function action() {
          if (quiz_states.indexOf($state.current.name) > -1) {
            if (confirm('You need to buy plan. Redirect to payment page, ok?')) {
              $state.go('base.store_payment_before_quiz');
            }
          } else
          {
            if (confirm('You need to buy plan. Redirect to payment page, ok?')) {
              $state.go('base.store_payment_before_quiz');
            }
          }
        } },

      '!user-!payed-!password-!quiz_part-!quiz-!measurements-!saved': {
        condition: function condition() {
          return !conditions['payed']() && !conditions['user-exist']() && !conditions['password-changed']() &&
          !conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() &&
          !conditions['user-saved-in-ss']();

        },
        action: function action() {
          if (quiz_states.indexOf($state.current.name) > -1) {
            if (confirm('Before this step you need to buy plan, ok?')) {
              $state.go('base.store_payment_before_quiz');
            }
          } else
          {
            if (confirm('You need to register and buy plan. Redirect to payment page, ok?')) {
              $state.go('base.store_payment_before_quiz');
            }
          }
        } },

      // default offer conditions
      'measurements-!quiz_part-quiz-user-payed-password': { // user finish funnel
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          conditions['user-exist']() && conditions['payed']() && conditions['password-changed']();
        },
        action: function action() {
          if (confirm('You already finished this step and can be redirect to dashboard, ok?')) {
            $state.go('gplans.userConsole');
          }
        } },

      'measurements-!quiz_part-quiz-user-payed-!password': { // user bought plan, quiz finished, but didn't changed password
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          conditions['user-exist']() && conditions['payed']() && !conditions['password-changed']();
        },
        action: function action() {
          if (confirm('You already finished this step and can be redirect to password set page, ok?')) {
            $state.go('base.store_account_info', { plan: _user.subscription_plan.slug });
          }
        } },

      'measurements-!quiz_part-quiz-user-!payed-!password': { // user finished quiz, but didn't bought plan
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          conditions['user-exist']() && !conditions['payed']() && !conditions['password-changed']();
        },
        action: function action() {
          if (['base.store_account_info'].indexOf($state.current.name) > -1) {
            if (confirm('Before this step you need to buy plan, ok?')) {
              $state.go('base.store');
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to payment page, ok?')) {
              $state.go('base.store');
            }
          }
        } },

      'measurements-!quiz_part-quiz-!user-!payed-!password': { // user didn't set email, quiz and measurement done
        condition: function condition() {
          return !conditions['quiz-part']() && conditions['quiz-finished']() && conditions['measurements-done']() &&
          !conditions['user-exist']() && !conditions['payed']() && !conditions['password-changed']();
        },
        action: function action() {
          if (['base.store'].indexOf($state.current.name) > -1) {
            if (confirm('Before this step you need to set your email, ok?')) {
              $state.go('funnel.register_after_quiz');
            }
          } else
          if (['base.store_account_info'].indexOf($state.current.name) > -1) {
            if (confirm('Before this step you need to buy plan, ok?')) {
              $state.go('base.store_payment_before_quiz');
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to user registration page, ok?')) {
              $state.go('funnel.register_after_quiz');
            }
          }
        } },

      'measurements-quiz_part-!quiz-!user-!payed-!password': { // user finish part of quiz
        condition: function condition() {
          if ($state.current.name == 'survey.question')
          return conditions['quiz-part']() && !conditions['quiz-finished']() && conditions['measurements-done']() && !conditions['user-exist']() && !conditions['payed']() &&
          !conditions['password-changed']() && $stateParams.question != _is_finish_quiz.length + 1;else

          return conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() && !conditions['user-exist']() && !conditions['payed']() &&
          !conditions['password-changed']();
        },
        action: function action() {
          if ($stateParams.question > _is_finish_quiz.length + 1) {
            if (confirm('You must be redirect to quiz question page, ok?')) {
              $state.go('survey.question', { surveyId: 1, question: _is_finish_quiz.length + 1 });
            }
          } else
          {
            if (confirm('You already finished this step and can be redirect to quiz question page, ok?')) {
              $state.go('survey.question', { surveyId: 1, question: _is_finish_quiz.length + 1 });
            }
          }
        } },

      'measurements-!quiz_part-!quiz-!user-!payed-!password': { // user do nothing
        condition: function condition() {
          return !conditions['quiz-part']() && !conditions['quiz-finished']() && conditions['measurements-done']() &&
          !conditions['user-exist']() && !conditions['payed']() && !conditions['password-changed']() &&
          ['base.select_meta', 'base.survey_start'].indexOf($state.current.name) == -1 && $stateParams.question != 1;
        },
        action: function action() {
          if (confirm('You need to start quiz from begin, ok?')) {
            $state.go('survey.question', { surveyId: 1, question: 1 });
          }
        } },

      '!measurements-!quiz_part-!quiz-!user-!payed-!password': { // user didn't set measurement and finish quiz
        condition: function condition() {
          return !conditions['quiz-part']() && !conditions['quiz-finished']() && !conditions['measurements-done']() && !conditions['user-exist']() && !conditions['payed']() && !conditions['password-changed']();
        },
        action: function action() {
          if (confirm('Before this step you need to set measurement, ok?')) {
            $location.path('/');
          }
        } } };



    var legacySale = {
      'quiz': {
        conditions: [
        pageConditions['!quiz_part-quiz-measurements-user-payed-password'],
        pageConditions['!quiz_part-quiz-measurements-user-payed-!password'],
        pageConditions['!quiz_part-quiz-measurements-user-!payed-!password'],
        pageConditions['!quiz_part-quiz-measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-quiz-!measurements-!user-!payed-!password'],
        pageConditions['quiz_part-!quiz-!measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-!quiz-!measurements-!user-!payed-!password']] },


      'survey.weight_age_form': {
        conditions: [
        pageConditions['!quiz_part-quiz-measurements-user-payed-password'],
        pageConditions['!quiz_part-quiz-measurements-user-payed-!password'],
        pageConditions['!quiz_part-quiz-measurements-user-!payed-!password'],
        pageConditions['!quiz_part-quiz-measurements-!user-!payed-!password'],
        pageConditions['quiz_part-!quiz-!measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-!quiz-!measurements-!user-!payed-!password']] },


      'base.calculate': {
        conditions: [
        pageConditions['!quiz_part-quiz-measurements-user-payed-password'],
        pageConditions['!quiz_part-quiz-measurements-user-payed-!password'],
        pageConditions['!quiz_part-quiz-measurements-user-!payed-!password'],
        pageConditions['!quiz_part-quiz-!measurements-!user-!payed-!password'],
        pageConditions['quiz_part-!quiz-!measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-!quiz-!measurements-!user-!payed-!password']] },


      'funnel.register_after_quiz': {
        conditions: [
        pageConditions['!quiz_part-quiz-measurements-user-payed-password'],
        pageConditions['!quiz_part-quiz-measurements-user-payed-!password'],
        pageConditions['!quiz_part-quiz-measurements-user-!payed-!password'],
        pageConditions['!quiz_part-quiz-!measurements-!user-!payed-!password'],
        pageConditions['quiz_part-!quiz-!measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-!quiz-!measurements-!user-!payed-!password']] },


      'payment': {
        conditions: [
        pageConditions['!quiz_part-quiz-measurements-user-payed-password'],
        pageConditions['!quiz_part-quiz-measurements-user-payed-!password'],
        pageConditions['!quiz_part-quiz-measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-quiz-!measurements-!user-!payed-!password'],
        pageConditions['quiz_part-!quiz-!measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-!quiz-!measurements-!user-!payed-!password']] },


      'base.store_account_info': {
        conditions: [
        pageConditions['!quiz_part-quiz-measurements-user-payed-password'],
        pageConditions['!quiz_part-quiz-measurements-user-!payed-!password'],
        pageConditions['!quiz_part-quiz-measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-quiz-!measurements-!user-!payed-!password'],
        pageConditions['quiz_part-!quiz-!measurements-!user-!payed-!password'],
        pageConditions['!quiz_part-!quiz-!measurements-!user-!payed-!password']] },


      'base.store_upsell': {
        conditions: [] } };



    var _funnels = {
      // control funnels
      // ControlUS: angular.copy(legacySale),
      // ControlInt: angular.copy(legacySale),
      // legacy sale funnels
      CbMatt: angular.copy(legacySale),
      CbMattUS: angular.copy(legacySale),
      Alan: angular.copy(legacySale),
      John: angular.copy(legacySale),
      NoTimer: angular.copy(legacySale),
      NoCeleb: angular.copy(legacySale),
      Free: angular.copy(legacySale),
      // straight sale funnels
      straightSale: {
        'base.store_payment_before_quiz': {
          conditions: [
          pageConditions['user-payed-password-!quiz_part-quiz-measurements-saved'],
          pageConditions['user-payed-password-!quiz_part-quiz-measurements-!saved'],
          pageConditions['user-payed-password-!quiz_part-quiz-!measurements-!saved'],
          pageConditions['user-payed-password-quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-payed-password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-payed-!password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-!payed-!password-!quiz_part-!quiz-!measurements-!saved']] },


        'base.store_account_info': {
          conditions: [
          pageConditions['user-payed-password-!quiz_part-quiz-measurements-saved'],
          pageConditions['user-payed-password-!quiz_part-quiz-measurements-!saved'],
          pageConditions['user-payed-password-!quiz_part-quiz-!measurements-!saved'],
          pageConditions['user-payed-password-quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-payed-password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-!payed-!password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['!user-!payed-!password-!quiz_part-!quiz-!measurements-!saved']] },


        'quiz': {
          conditions: [
          pageConditions['user-payed-password-!quiz_part-quiz-measurements-saved'],
          pageConditions['user-payed-password-!quiz_part-quiz-measurements-!saved'],
          pageConditions['user-payed-password-!quiz_part-quiz-!measurements-!saved'],
          pageConditions['user-payed-password-quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-payed-!password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-!payed-!password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['!user-!payed-!password-!quiz_part-!quiz-!measurements-!saved']] },


        'survey.weight_age_form': {
          conditions: [
          pageConditions['user-payed-password-!quiz_part-quiz-measurements-saved'],
          pageConditions['user-payed-password-!quiz_part-quiz-measurements-!saved'],
          pageConditions['user-payed-password-quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-payed-password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-payed-!password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['user-!payed-!password-!quiz_part-!quiz-!measurements-!saved'],
          pageConditions['!user-!payed-!password-!quiz_part-!quiz-!measurements-!saved']] },


        'base.store_upsell': {
          conditions: [] } },



      // nutritionist funnel
      Nutritionist: angular.copy(legacySale),

      // default (home page/ fallback) funnel
      default1: angular.copy(legacySale)
      /*
                                         default1: {
                                           'quiz': {
                                             conditions: [
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-!user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['measurements-quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['!measurements-!quiz_part-!quiz-!user-!payed-!password']
                                             ]
                                           },
                                           'survey.weight_age_form': {
                                             conditions: [
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-!user-!payed-!password'],
                                               pageConditions['measurements-quiz_part-!quiz--!user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['!measurements-!quiz_part-!quiz-!user-!payed-!password']
                                             ]
                                           },
                                           'base.calculate': {
                                             conditions: [
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-!user-!payed-!password'],
                                               pageConditions['measurements-quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['!measurements-!quiz_part-!quiz-!user-!payed-!password']
                                             ]
                                           },
                                           'funnel.register_after_quiz': {
                                             conditions: [
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-!user-!payed-!password'],
                                               pageConditions['measurements-quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['!measurements-!quiz_part-!quiz-!user-!payed-!password']
                                             ]
                                           },
                                           'payment': {
                                             conditions: [
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-!user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-!user-!payed-!password'],
                                               pageConditions['measurements-quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['!measurements-!quiz_part-!quiz-!user-!payed-!password']
                                             ]
                                           },
                                           'base.store_account_info': {
                                             conditions: [
                                               pageConditions['measurements-!quiz_part-quiz-user-payed-password'],
                                               pageConditions['measurements-!quiz_part-quiz-user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-!user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-quiz-!user-!payed-!password'],
                                               pageConditions['measurements-quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['measurements-!quiz_part-!quiz-!user-!payed-!password'],
                                               pageConditions['!measurements-!quiz_part-!quiz-!user-!payed-!password']
                                             ]
                                           },
                                           'base.store_upsell': {
                                             conditions: []
                                           }
                                         }
                                         */ };


    var _multiRegionalFunnels = ['CbMatt'];

    var _templates = {
      'base.store': 'checkout',
      'base.blood_type_complete': 'complete',
      'base.complete': 'complete',
      'base.store_payment': 'payment',
      'survey.question': 'question',
      'base.store_upsell': 'upsell',
      'base.store_upsell_next': 'upsell-bundle',
      'base.store_downsell': 'upsell-down',
      'base.store_downsell_nutritionist': 'upsell-down-nutritionist',
      'base.store_upsell_nutritionist': 'upsell-nutritionist' };


    var funnel = {
      redirect: redirect,
      nextStep: nextStep,
      getStep: getStep,
      getTemplateUrl: getTemplateUrl };


    _setLocation();
    return funnel;

    function getStep() {
      var step = $state.current.name;
      if (quiz_states.indexOf(step) > -1) {step = 'quiz';} else
      if (payment_states.indexOf(step) > -1) {step = 'payment';}
      return step;
    }

    function nextStep(callback, param) {
      var _offerId = $rootScope.offerId;
      if (_offerId && _multiRegionalFunnels.indexOf(_offerId) > -1 && _location === 'US') _offerId += 'US';

      if (_offerId && _funnelNextStepDict[_offerId]) var steps = _funnelNextStepDict[_offerId].steps;else
      var steps = _funnelNextStepDict['default1'].steps;
      for (var i = 0; i < steps.length; i++) {
        var step = steps[i];
        if (step.condition()) {step.action(callback, param);break;}
      }
    }

    function redirect(state) {
      if (_user === null) {
        if ($localStorage['userSurvey']) {
          var requestQuiz = $http.get(gplansConf.API_URL + '/api/v1/usersurveys/' + $localStorage['userSurvey'] + '/surveyanswers/');
        } else
        {
          var requestQuiz = $q.resolve(undefined);
        }
        _state = state;
        var requestUser = _getUser();
        return $q.all([requestQuiz, requestUser]).then(_makeAction);
      }
    }

    function getTemplateUrl(stateName) {
      // TODO : exception if there's no mapping for stateName
      var templateName = _templates[stateName];
      var templateUrl;
      var folder = 'default';

      if ($rootScope.offerId) {
        folder = $rootScope.offerId;
        if (_multiRegionalFunnels.indexOf($rootScope.offerId) > -1 && _location === 'US') {
          folder += 'US';
        }
      }

      templateUrl = 'templates/funnels/' + folder + '/' + templateName + '.html';
      return templateUrl;
    }

    function _makeAction(data) {
      var _offerId = $rootScope.offerId;
      if (_offerId && _multiRegionalFunnels.indexOf(_offerId) > -1 && _location === 'US') _offerId += 'US';

      _user = data[1];
      _is_finish_quiz = data[0] && data[0].data.length ? data[0].data : false;
      var _offerId = _offerId && _funnels[_offerId] ? _offerId : 'default1';
      var conditions = ((_funnels[_offerId] || {})[_state] || {}).conditions || [];
      for (var i = 0; i < conditions.length; i++) {
        var condition = conditions[i];
        if (condition && condition.condition()) {condition.action();break;}
      }
    }

    function _getUser() {
      var check_now = true;
      return Authentication.getAuthenticatedAccount(check_now).catch(function (err) {
        return $q(function (resolve, reject) {
          resolve(undefined);
        });
      });
    }

    function _setLocation() {
      var url = 'https://geoip-db.com/jsonp/';
      var trustedUrl = $sce.trustAsResourceUrl(url);

      _location = _defaultLocation;

      $http.jsonp(trustedUrl, { jsonpCallbackParam: 'callback' });
      // .then(function( location ){
      //   if (location.country_name === "United States") {
      //     _location = 'US';
      //   } else {
      //     _location = 'Int';
      //   }
      // });
      // TODO : that's bad but it doesn't recognize angular callback ^, possible to fix?
      window.callback = function (location) {
        if (location.country_name === "United States" || location.country_name === "Not found") {
          _location = 'US';
        } else {
          _location = 'Int';
        }
      };
    }

  }
})();